var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('primary-button',{staticClass:"padding-12",attrs:{"disabled":_setup.hasApplication},on:{"click":function($event){return _setup.emit('click')}}},[_vm._v(_vm._s(_vm.isApplication ? _setup.getApplicationButtonLabel() : _setup.t("applyButton")))])
}
var staticRenderFns = []

export { render, staticRenderFns }